"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#DBDDEB",
  d: "M6 4.046h13.818v13.46l-3.589.448V7.635H6.36L6 4.045Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 8h12v12H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5665A1",
  fillRule: "evenodd",
  d: "M5.621 3.7a.7.7 0 0 1 .7-.7h13.98a.7.7 0 0 1 .7.7v13.979a.7.7 0 0 1-.7.7h-3.087V20.3a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V7.486a.7.7 0 0 1 .7-.7h1.943a.702.702 0 0 1-.022-.174V3.7ZM7 6.786h9.515a.7.7 0 0 1 .7.7v9.493H19.6V4.4H7.021v2.212a.67.67 0 0 1-.022.174Zm-2.6 1.4v7.41c2.507-1.078 7.027-1.982 11.414-.579V8.186H4.4Zm11.414 8.31c-4.388-1.577-9.075-.505-11.28.58a.704.704 0 0 1-.134.049V19.6h11.414v-3.104Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5665A1",
  d: "M8.485 11.386a1.024 1.024 0 1 1-2.048 0 1.024 1.024 0 0 1 2.048 0Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ContentLibraryColorIcon24.js.map